import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {EditorContent} from '@tiptap/react';
import {useSelector} from 'react-redux';
import QuestionElement from '../../../../components/elements/question/question/QuestionElement';
import {PresScaleProvider} from '../../../../context/PresScaleContext';
import {IPresentationTheme} from '../../../../incase-domain/presentationTheme';
import {AppState} from '../../../../store/reducer';
import {editorSelector} from '../../../../store/selectors/tiptapEditor.selectors';
import {getBorderStyle} from '../../../../utils/style.utils';
import {buildThemeQuestionPreviewElement} from './buildThemeQuestionPreviewElement';
import {PresentationThemeTab} from './PresentationThemeModal';

export const THEME_TEXT_PREVIEW_ID = 'presentation-theme-text-preview';

interface ThemePreviewPanelProps {
    activeTab: PresentationThemeTab;
    presentationTheme: IPresentationTheme;
}

function ThemePreviewPanel({activeTab, presentationTheme}: ThemePreviewPanelProps): JSX.Element {
    const {t} = useTranslation();
    const textTheme = presentationTheme.elementStyles?.textElement;
    const textEditor = useSelector((state: AppState) => editorSelector(state, THEME_TEXT_PREVIEW_ID));
    const questionPreviewElement = useMemo(() => buildThemeQuestionPreviewElement(presentationTheme), [presentationTheme]);

    return (
        <PresScaleProvider>
            <div className="c-themePreview">
                <div className="c-themePreview__label">{t('presentationThemesPage.preview')}</div>
                <div className="c-themePreview__canvas">
                    <div>
                        {activeTab === PresentationThemeTab.TEXT && (
                            <div
                                className="c-themePreview__text c-tiptap c-textElement ql-editor"
                                style={{
                                    color: textTheme?.color || undefined,
                                    backgroundColor: textTheme?.backgroundColor || '#fff',
                                    borderRadius: getBorderStyle(textTheme?.borderRadius) || undefined,
                                    fontSize: textTheme?.fontSize?.value ? `${textTheme.fontSize.value}em` : '1em',
                                }}
                            >
                                {textEditor ? <EditorContent editor={textEditor} /> : t('presentationThemesPage.text.textElement')}
                            </div>
                        )}

                        {activeTab === PresentationThemeTab.QUESTION && (
                            <div className="c-themePreview__question">
                                <QuestionElement element={questionPreviewElement} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </PresScaleProvider>
    );
}

export default ThemePreviewPanel;
